module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/PlayIconHover.cea3eb44.svg";